import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt", "loading"]

import fallbackImage from '@/static/icons/missing-image.svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageWithFallback',
  props: {
  image: {
    type: String,
    default: fallbackImage,
  },
  alt: {
    type: String,
    default: '',
  },
  loading: {
    type: String,
    default: 'eager',
  },
},
  setup(__props) {



function useFallback(event: Event) {
  const eventTarget = event.target as HTMLImageElement;
  eventTarget.src = fallbackImage;
  eventTarget.onerror = null;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: __props.image,
    alt: __props.alt,
    onerror: useFallback,
    loading: __props.loading,
    decoding: "async"
  }, null, 8, _hoisted_1))
}
}

})